import { useState, useEffect } from 'react';
import { api } from '../api';

export default function Inventario() {
  const [marcas, setMarcas] = useState([]);
  const [marcaSeleccionada, setMarcaSeleccionada] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [busquedaProducto, setBusquedaProducto] = useState('');
  const [top25, setTop25] = useState(null);
  const [dataMarca, setDataMarca] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [productoDetalle, setProductoDetalle] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const [modalAbierto, setModalAbierto] = useState(false);

  useEffect(() => { cargarInicial(); }, []);

  const cargarInicial = async () => {
    setCargando(true);
    try {
      const [marcasData, topData] = await Promise.all([
        api.get('/inventario/marcas'),
        api.get('/inventario/top')
      ]);
      setMarcas(marcasData.marcas || []);
      setTop25(topData.productos || []);
    } catch (e) { console.error(e); }
    finally { setCargando(false); }
  };

  const seleccionarMarca = async (marca) => {
    setMarcaSeleccionada(marca);
    setBusquedaProducto('');
    setCargando(true);
    try {
      const data = await api.get(`/inventario/marca?marca=${encodeURIComponent(marca)}`);
      setDataMarca(data);
    } catch (e) { console.error(e); }
    finally { setCargando(false); }
  };

  const limpiar = () => {
    setMarcaSeleccionada('');
    setDataMarca(null);
    setBusqueda('');
    setBusquedaProducto('');
  };

  const abrirDetalle = async (codigo) => {
    setModalAbierto(true);
    setCargandoDetalle(true);
    setProductoDetalle(null);
    try {
      const data = await api.get(`/inventario/producto/${codigo}`);
      setProductoDetalle(data);
    } catch (e) { console.error(e); }
    finally { setCargandoDetalle(false); }
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setProductoDetalle(null);
  };

  const marcasFiltradas = marcas.filter(m =>
    m.toLowerCase().includes(busqueda.toLowerCase())
  );

  const productosFiltrados = (dataMarca?.productos || []).filter(p =>
    p.item.toLowerCase().includes(busquedaProducto.toLowerCase()) ||
    p.codigo.toString().includes(busquedaProducto) ||
    (p.codigo_bar || '').toLowerCase().includes(busquedaProducto.toLowerCase())
  );

  return (
    <div style={s.wrapper}>
      <div style={s.container}>
        {/* Sidebar */}
        <div style={s.sidebar}>
          <div style={s.sidebarHeader}>
            <div style={s.sidebarTitulo}>🏷️ Marcas</div>
            <span style={s.marcasCount}>{marcas.length}</span>
          </div>
          <input style={s.searchInput} value={busqueda} onChange={e => setBusqueda(e.target.value)} placeholder="Buscar marca..." />
          <div style={s.marcasList}>
            <div style={{...s.marcaItem, ...(marcaSeleccionada === '' ? s.marcaItemActivo : {})}} onClick={limpiar}>
              📦 Top 25 Stock
            </div>
            {marcasFiltradas.map(m => (
              <div key={m} style={{...s.marcaItem, ...(marcaSeleccionada === m ? s.marcaItemActivo : {})}} onClick={() => seleccionarMarca(m)}>
                {m}
              </div>
            ))}
          </div>
        </div>

        {/* Main */}
        <div style={s.main}>
          {cargando ? (
            <p style={s.cargando}>Cargando...</p>
          ) : marcaSeleccionada === '' ? (
            <>
              <h2 style={s.titulo}>📦 Top 25 — Mayor Stock</h2>
              <p style={s.subtitulo}>Productos con mayor stock en bodega · haz click en un producto para ver su detalle</p>
              <TablaProductos productos={top25} showMarca={true} onClickProducto={abrirDetalle} />
            </>
          ) : (
            <>
              <div style={s.marcaHeader}>
                <div>
                  <h2 style={s.titulo}>🏷️ {marcaSeleccionada}</h2>
                  <p style={s.subtitulo}>Inventario completo en BOD. ESTACION · haz click en un producto para ver su detalle</p>
                </div>
                <button style={s.botonLimpiar} onClick={limpiar}>← Volver</button>
              </div>
              {dataMarca && (
                <>
                  <div style={s.kpisRow}>
                    <div style={s.kpiCard}>
                      <div style={s.kpiValor}>{dataMarca.resumen.total_productos}</div>
                      <div style={s.kpiLabel}>Productos</div>
                    </div>
                    <div style={{...s.kpiCard, borderTopColor: '#4cc9f0'}}>
                      <div style={s.kpiValor}>{dataMarca.resumen.stock_total.toFixed(0)}</div>
                      <div style={s.kpiLabel}>Unidades en stock</div>
                    </div>
                    <div style={{...s.kpiCard, borderTopColor: '#f72585'}}>
                      <div style={s.kpiValor}>${dataMarca.resumen.valor_inventario.toFixed(2)}</div>
                      <div style={s.kpiLabel}>Valor inventario</div>
                    </div>
                  </div>
                  <input style={s.searchProducto} value={busquedaProducto} onChange={e => setBusquedaProducto(e.target.value)} placeholder="Buscar producto por descripción o código..." />
                  <TablaProductos productos={productosFiltrados} showMarca={false} onClickProducto={abrirDetalle} />
                </>
              )}
            </>
          )}
        </div>
      </div>

      {/* Modal */}
      {modalAbierto && (
        <div style={s.modalOverlay} onClick={cerrarModal}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>

            {/* Header */}
            <div style={s.modalHeader}>
              <span style={s.modalTitulo}>
                {productoDetalle?.ultima_compra?.producto || 'Detalle del producto'}
              </span>
              <button style={s.modalCerrar} onClick={cerrarModal}>✕</button>
            </div>

            {cargandoDetalle ? (
              <p style={{...s.cargando, padding: 60}}>Cargando detalle...</p>
            ) : productoDetalle?.error ? (
              <p style={{ color: '#e63946', padding: 28 }}>{productoDetalle.error}</p>
            ) : productoDetalle ? (
              <>
                {/* FILA SUPERIOR — Detalle última compra */}
                <div style={s.filaCompra}>
                  <div style={s.filaCompraInner}>
                    {/* Datos compra */}
                    <div style={s.compraGrid}>
                      {[
                        ['Fecha', productoDetalle.ultima_compra.fecha],
                        ['Proveedor', productoDetalle.ultima_compra.proveedor],
                        ['RUC', productoDetalle.ultima_compra.ruc_proveedor],
                        ['Factura', productoDetalle.ultima_compra.factura],
                        ['Forma de pago', productoDetalle.ultima_compra.forma_pago],
                        ['Cantidad comprada', `${productoDetalle.ultima_compra.cantidad_comprada.toFixed(0)} ${productoDetalle.ultima_compra.unidad}`],
                        ['Costo unitario', `$${productoDetalle.ultima_compra.costo.toFixed(2)}`],
                        ['IVA', `${productoDetalle.ultima_compra.iva_pct}%`],
                        ['PVP', `$${productoDetalle.ultima_compra.pvp.toFixed(2)}`],
                      ].map(([label, valor], i) => (
                        <div key={label} style={{...s.compraItem, ...(label === 'PVP' ? {color: '#4cc9f0', fontWeight: 'bold'} : {})}}>
                          <span style={s.compraLabel}>{label}</span>
                          <span style={{...s.compraValor, ...(label === 'PVP' ? {color: '#4cc9f0', fontWeight: 'bold'} : {})}}>{valor}</span>
                        </div>
                      ))}
                    </div>

                    {/* Stock */}
                    <div style={s.stockWrap}>
                      <div style={s.seccionTitulo}>📦 STOCK</div>
                      <div style={s.stockRow}>
                        <div style={s.stockCard}>
                          <div style={s.stockNum}>{productoDetalle.ultima_compra.stock_anterior.toFixed(0)}</div>
                          <div style={s.stockLabel}>Antes de compra</div>
                        </div>
                        <div style={s.stockArrow}>→</div>
                        <div style={{...s.stockCard, borderColor: '#4cc9f0'}}>
                          <div style={{...s.stockNum, color: '#4cc9f0'}}>{productoDetalle.ultima_compra.stock_actual.toFixed(0)}</div>
                          <div style={s.stockLabel}>Stock actual</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* FILA INFERIOR — Ventas con scroll */}
                <div style={s.filaVentas}>
                  <div style={s.ventasTopBar}>
                    <span style={s.seccionTitulo}>📊 VENTAS DESDE ÚLTIMA COMPRA</span>
                    <div style={s.ventasResumen}>
                      <span style={s.ventasBadge}>{productoDetalle.total_vendido.toFixed(0)} unidades</span>
                      <span style={{...s.ventasBadge, background: '#1a3a2a', color: '#4caf50'}}>
                        ${productoDetalle.total_revenue.toFixed(2)} revenue
                      </span>
                    </div>
                  </div>

                  {productoDetalle.ventas.length === 0 ? (
                    <p style={{ color: '#555', fontSize: 13, padding: '16px 0' }}>Sin ventas desde la última compra</p>
                  ) : (
                    <div style={s.ventasTabla}>
                      <div style={s.ventasHeader}>
                        <span style={{ flex: 2 }}>Fecha</span>
                        <span style={{ flex: 4 }}>Cliente</span>
                        <span style={{ flex: 2 }}>Factura</span>
                        <span style={{ width: 60, textAlign: 'right' }}>Cant.</span>
                        <span style={{ width: 80, textAlign: 'right' }}>Precio</span>
                      </div>
                      <div style={s.ventasScroll}>
                        {productoDetalle.ventas.map((v, i) => (
                          <div key={i} style={{...s.ventasRow, background: i % 2 === 0 ? '#1a1a2e' : '#1e1e2e'}}>
                            <span style={{ flex: 2, color: '#aaa', fontSize: 12 }}>{v.fecha}</span>
                            <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{v.cliente}</span>
                            <span style={{ flex: 2, color: '#555', fontSize: 12 }}>{v.factura}</span>
                            <span style={{ width: 60, textAlign: 'right', color: '#fff', fontWeight: 'bold', fontSize: 13 }}>{v.cantidad.toFixed(0)}</span>
                            <span style={{ width: 80, textAlign: 'right', color: '#4cc9f0', fontSize: 13 }}>${v.precio.toFixed(2)}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}

function TablaProductos({ productos, showMarca, onClickProducto }) {
  if (!productos || productos.length === 0) return (
    <p style={{ color: '#555', textAlign: 'center', marginTop: 40 }}>Sin productos</p>
  );
  const maxStock = productos[0]?.stock || 1;
  return (
    <div style={s.tabla}>
      <div style={s.tablaHeader}>
        <span style={{ flex: 1 }}>CÓDIGO</span>
        <span style={{ flex: 4 }}>DESCRIPCIÓN</span>
        {showMarca && <span style={{ flex: 1 }}>MARCA</span>}
        <span style={{ width: 120, textAlign: 'right' }}>STOCK</span>
        <span style={{ width: 100, textAlign: 'right' }}>COSTO</span>
        <span style={{ width: 110, textAlign: 'right' }}>VALOR</span>
      </div>
      {productos.map((p, i) => (
        <div key={i}
          style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e', cursor: 'pointer'}}
          onClick={() => onClickProducto(p.codigo)}
          onMouseEnter={e => e.currentTarget.style.background = '#2d2d44'}
          onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}
        >
          <span style={{ flex: 1, color: '#fff', fontSize: 11 }}>{p.codigo_bar || p.codigo}</span>
          <span style={{ flex: 4, color: '#fff', fontSize: 13 }}>{p.item}</span>
          {showMarca && <span style={{ flex: 1, color: '#4cc9f0', fontSize: 12 }}>{p.marca}</span>}
          <div style={{ width: 120, textAlign: 'right' }}>
            <div style={s.barraContainer}>
              <div style={{ ...s.barraFill, width: `${(p.stock / maxStock) * 100}%` }} />
            </div>
            <span style={{ color: '#fff', fontWeight: 'bold', fontSize: 13 }}>{p.stock.toFixed(0)}</span>
          </div>
          <span style={{ width: 100, textAlign: 'right', color: '#aaa', fontSize: 13 }}>${p.costo.toFixed(2)}</span>
          <span style={{ width: 110, textAlign: 'right', color: '#4cc9f0', fontSize: 13 }}>${p.valor.toFixed(2)}</span>
        </div>
      ))}
    </div>
  );
}

const s = {
  wrapper: { position: 'relative' },
  container: { display: 'flex', gap: 0, minHeight: 'calc(100vh - 64px)', margin: '-32px' },
  sidebar: { width: 220, background: '#1a1a2e', borderRight: '1px solid #2d2d44', display: 'flex', flexDirection: 'column', padding: 16, height: 'calc(100vh - 64px)', overflowY: 'hidden', position: 'sticky', top: 0 },
  sidebarHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 },
  sidebarTitulo: { color: '#fff', fontWeight: 'bold', fontSize: 14 },
  marcasCount: { background: '#2d2d44', color: '#aaa', borderRadius: 10, padding: '2px 8px', fontSize: 11 },
  searchInput: { background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 6, color: '#fff', padding: '8px 10px', fontSize: 12, marginBottom: 8, width: '100%', boxSizing: 'border-box' },
  marcasList: { flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 2, maxHeight: 'calc(100vh - 180px)' },
  marcaItem: { padding: '8px 10px', borderRadius: 6, cursor: 'pointer', color: '#888', fontSize: 12 },
  marcaItemActivo: { background: '#2d2d44', color: '#fff' },
  main: { flex: 1, padding: 32, overflowY: 'auto' },
  titulo: { color: '#fff', marginBottom: 4 },
  subtitulo: { color: '#555', fontSize: 13, marginBottom: 24 },
  marcaHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 },
  botonLimpiar: { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer' },
  kpisRow: { display: 'flex', gap: 16, marginBottom: 24 },
  kpiCard: { background: '#1e1e2e', borderRadius: 12, padding: 20, flex: 1, borderTop: '3px solid #7209b7' },
  kpiValor: { color: '#fff', fontSize: 28, fontWeight: 'bold', marginBottom: 4 },
  kpiLabel: { color: '#aaa', fontSize: 12 },
  cargando: { color: '#aaa', textAlign: 'center' },
  tabla: { borderRadius: 12, overflow: 'hidden' },
  tablaHeader: { display: 'flex', padding: '10px 16px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8 },
  tablaRow: { display: 'flex', padding: '10px 16px', gap: 8, alignItems: 'center', transition: 'background 0.15s' },
  barraContainer: { background: '#2a2a3e', borderRadius: 3, height: 4, marginBottom: 3 },
  barraFill: { height: 4, borderRadius: 3, background: '#7209b7' },
  searchProducto: { background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '10px 14px', fontSize: 13, width: '100%', marginBottom: 16, boxSizing: 'border-box' },

  // Modal
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.75)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 },
  modal: { background: '#1a1a2e', borderRadius: 16, border: '1px solid #2d2d44', width: '90%', maxWidth: 800, maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 28px', borderBottom: '1px solid #2d2d44', flexShrink: 0 },
  modalTitulo: { color: '#fff', fontSize: 15, fontWeight: 'bold', flex: 1, marginRight: 16 },
  modalCerrar: { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', fontSize: 16, cursor: 'pointer', padding: '6px 12px' },

  // Fila superior — compra
  filaCompra: { borderBottom: '1px solid #2d2d44', padding: '20px 28px', flexShrink: 0 },
  filaCompraInner: { display: 'flex', gap: 32, alignItems: 'flex-start' },
  compraGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px 24px', flex: 1 },
  compraItem: { display: 'flex', flexDirection: 'column', gap: 2 },
  compraLabel: { color: '#555', fontSize: 11 },
  compraValor: { color: '#fff', fontSize: 13 },
  stockWrap: { minWidth: 200 },
  seccionTitulo: { color: '#4cc9f0', fontSize: 11, fontWeight: 'bold', letterSpacing: 1, marginBottom: 12 },
  stockRow: { display: 'flex', alignItems: 'center', gap: 12 },
  stockCard: { flex: 1, background: '#0f0f1a', borderRadius: 8, padding: '12px 8px', textAlign: 'center', border: '1px solid #2d2d44' },
  stockNum: { color: '#fff', fontSize: 24, fontWeight: 'bold' },
  stockLabel: { color: '#555', fontSize: 10, marginTop: 4 },
  stockArrow: { color: '#555', fontSize: 18 },

  // Fila inferior — ventas
  filaVentas: { flex: 1, display: 'flex', flexDirection: 'column', padding: '20px 28px', overflow: 'hidden' },
  ventasTopBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8, flexShrink: 0 },
  ventasResumen: { display: 'flex', gap: 8 },
  ventasBadge: { background: '#1a2a3e', color: '#4cc9f0', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 'bold' },
  ventasTabla: { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', borderRadius: 8 },
  ventasHeader: { display: 'flex', padding: '8px 14px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8, flexShrink: 0 },
  ventasScroll: { overflowY: 'auto', flex: 1 },
  ventasRow: { display: 'flex', padding: '9px 14px', gap: 8, alignItems: 'center' },
};
